import React from 'react';
import Toggle from 'material-ui/Toggle';
import * as Colors from '../../utils/Color';


const styles = {
    thumbOff: {
        backgroundColor: Colors.primary,
    },
    trackOff: {
        backgroundColor: Colors.primary50,
    },
    thumbSwitched: {
        backgroundColor: Colors.secondary,
    },
    trackSwitched: {
        backgroundColor: Colors.secondary50,
    }
};

const SwitchToggle = props => {
    const { name, onChange, label, value } = props;
    return (
        <Toggle
            name={name}
            onToggle={ (e, isInputChecked) => onChange(name, isInputChecked) }
            toggled={ value }
            className="switch-toggle"
            thumbStyle={styles.thumbOff}
            trackStyle={styles.trackOff}
            thumbSwitchedStyle={styles.thumbSwitched}
            trackSwitchedStyle={styles.trackSwitched}
            style={{width: '36px'}}
        />
    )
};

export default SwitchToggle;



// WEBPACK FOOTER //
// ./src/components/UI/SwitchToggle-f.js